export const columnWidths = {
  dragHandle: '3%',
  thumbnail: '12%',
  code: '12%',
  mechanism: '12%',
  branch: '10%',
  cg1: '8%',
  cg2: '8%',
  usage: '8%',
  activeStatus: '10%',
  displayStatus: '11%',
  actions: '10%',
};
